import { z } from "zod";

import { commandType } from "./Attributes";

export const Schema = () =>
    z.object({
        type: z.literal(commandType),
        settings: z.object({
            recording: z.boolean(),
        }),
    });
